import { useDataChange } from 'Simple/Data.js'

export let PAYOR_FILTERS = /** @type {const} */ ({
  EXISTING: 'EXISTING',
  NEW: 'NEW',
})

function usePayorFilterChange(props, filter) {
  let change = useDataChange({
    context: 'selected',
    path: 'filter',
    viewPath: props.viewPath,
  })

  return function onChange() {
    change(filter)
  }
}

export function useOnClickExisting(props) {
  return usePayorFilterChange(props, PAYOR_FILTERS.EXISTING)
}

export function useOnClickNew(props) {
  return usePayorFilterChange(props, PAYOR_FILTERS.NEW)
}
